module.exports = __webpack_public_path__ + "static/Tastea0-2a5078d4f2f8fefa8659e36a0b0e8fdc.jpg";